import type { AgentStreamEvent } from '@erp/rpc';
import type { ToolCall } from '@/context/agent-state.context';

export interface ProjectChatStreamState {
  streamingText: string;
  error: string | null;
  activeToolCalls: ToolCall[];
}

export const EMPTY_PROJECT_CHAT_STREAM: ProjectChatStreamState = {
  streamingText: '',
  error: null,
  activeToolCalls: [],
};

function completeToolCall(
  toolCalls: ToolCall[],
  event: Extract<AgentStreamEvent, { type: 'tool-result' }>,
): ToolCall[] {
  return toolCalls.map((toolCall) =>
    toolCall.toolCallId === event.toolCallId
      ? { ...toolCall, result: event.result, status: 'complete' }
      : toolCall,
  );
}

export function reduceProjectChatStream(
  state: ProjectChatStreamState,
  event: AgentStreamEvent,
): ProjectChatStreamState {
  switch (event.type) {
    case 'text-delta':
      return { ...state, streamingText: state.streamingText + event.text };
    case 'tool-call':
      return {
        ...state,
        activeToolCalls: [
          ...state.activeToolCalls,
          {
            toolCallId: event.toolCallId,
            toolName: event.toolName,
            userFacingName: event.userFacingName,
            isWrite: event.isWrite,
            args: event.args,
            status: 'pending',
            createdAt: Date.now(),
          },
        ],
      };
    case 'tool-result':
      return {
        ...state,
        activeToolCalls: completeToolCall(state.activeToolCalls, event),
      };
    case 'error':
      return { ...state, error: event.message };
    default:
      return state;
  }
}
